/** @format */

import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import LayoutAcademia from "../componentes/LayoutAcademia";
import LayoutAluno from "../componentes/LayoutAluno";
import LayoutInstrutor from "../componentes/LayoutInstrutor";
import AcademiaHome from "../paginas/academia";
import QuemSomos from "../paginas/QuemSomos";
import CursosAcademia from "../paginas/publicas/Cursos";
import ContatoAcademia from "../paginas/publicas/ContatoAcademia";
import CursoDetalhe from "../paginas/publicas/CursoDetalhe";
import Curso1 from "../paginas/publicas/Cursos/curso1";
import Curso2 from "../paginas/publicas/Cursos/curso2";
import Curso3 from "../paginas/publicas/Cursos/curso3";
import Curso4 from "../paginas/publicas/Cursos/curso4";
import LoginAcademia from "../paginas/autenticacao/Login";
import CadastroAcademia from "../paginas/autenticacao/Cadastro";
import RecuperarSenha from "../paginas/autenticacao/RecuperarSenha";

import LayoutAdmin from "../componentes/LayoutAdmin";
import AdminPainel from "../paginas/admin/Painel";
import GerirCursos from "../paginas/admin/GerirCursos";
import GerirDestaques from "../paginas/admin/GerirDestaques";
import GerirCategorias from "../paginas/admin/GerirCategorias";
import GerirInscricoes from "../paginas/admin/GerirInscricoes";
import GerenciarUsuarios from "../paginas/admin/GerenciarUsuarios";
import Relatorios from "../paginas/admin/Relatorios";
import Configuracoes from "../paginas/admin/Configuracoes";
import PerfilAdmin from "../paginas/admin/Perfil";
import InstrutorPainel from "../paginas/instrutor/Painel";
import { default as GerenciarCursos } from "../paginas/instrutor/GerenciarCursos";
import Estatisticas from "../paginas/instrutor/Estatisticas";
import GerenciarAulas from "../paginas/instrutor/GerenciarAulas";
import ConfiguracoesInstrutor from "../paginas/instrutor/Configuracoes";
import AlunoPainel from "../paginas/aluno/Painel";
import MeusCursos from "../paginas/aluno/MeusCursos";
import Certificados from "../paginas/aluno/Certificados";
import Favoritos from "../paginas/aluno/Favoritos";
import Avaliacoes from "../paginas/aluno/Avaliacoes";
import Aula from "../paginas/aluno/Aula";
import AlunoConfiguracoes from "../paginas/aluno/Configuracoes";

const RotasAcademia = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          {/* Rotas públicas */}
          <Route
            path="/"
            element={
              <LayoutAcademia>
                <AcademiaHome />
              </LayoutAcademia>
            }
          />
          <Route
            path="/login"
            element={
              <LayoutAcademia>
                <LoginAcademia />
              </LayoutAcademia>
            }
          />
          <Route
            path="/cadastro"
            element={
              <LayoutAcademia>
                <CadastroAcademia />
              </LayoutAcademia>
            }
          />
          <Route
            path="/recuperar-senha"
            element={
              <LayoutAcademia>
                <RecuperarSenha />
              </LayoutAcademia>
            }
          />

          {/* Rotas Admin */}
          <Route
            path="/admin"
            element={
              <LayoutAdmin>
                <AdminPainel />
              </LayoutAdmin>
            }
          />
          <Route
            path="/admin/cursos"
            element={
              <LayoutAdmin>
                <GerirCursos />
              </LayoutAdmin>
            }
          />
          <Route
            path="/admin/destaques"
            element={
              <LayoutAdmin>
                <GerirDestaques />
              </LayoutAdmin>
            }
          />
          <Route
            path="/admin/categorias"
            element={
              <LayoutAdmin>
                <GerirCategorias />
              </LayoutAdmin>
            }
          />
          <Route
            path="/admin/inscricoes"
            element={
              <LayoutAdmin>
                <GerirInscricoes />
              </LayoutAdmin>
            }
          />
          <Route
            path="/admin/usuarios"
            element={
              <LayoutAdmin>
                <GerenciarUsuarios />
              </LayoutAdmin>
            }
          />
          <Route
            path="/admin/relatorios"
            element={
              <LayoutAdmin>
                <Relatorios />
              </LayoutAdmin>
            }
          />
          <Route
            path="/admin/configuracoes"
            element={
              <LayoutAdmin>
                <Configuracoes />
              </LayoutAdmin>
            }
          />
          <Route
            path="/admin/perfil"
            element={
              <LayoutAdmin>
                <PerfilAdmin />
              </LayoutAdmin>
            }
          />{/* Rotas Protegidas - Instrutor */}
          <Route
            path="/instrutor"
            element={
              <LayoutAcademia>
                <LayoutInstrutor>
                  <InstrutorPainel />
                </LayoutInstrutor>
              </LayoutAcademia>
            }
          />
          <Route
            path="/instrutor/gerenciar-cursos"
            element={
              <LayoutAcademia>
                <LayoutInstrutor>
                  <GerenciarCursos />
                </LayoutInstrutor>
              </LayoutAcademia>
            }
          />
          <Route
            path="/instrutor/estatisticas"
            element={
              <LayoutAcademia>
                <LayoutInstrutor>
                  <Estatisticas />
                </LayoutInstrutor>
              </LayoutAcademia>
            }
          />
          <Route
            path="/instrutor/gerenciar-aulas"
            element={
              <LayoutAcademia>
                <LayoutInstrutor>
                  <GerenciarAulas />
                </LayoutInstrutor>
              </LayoutAcademia>
            }
          />
          <Route
            path="/instrutor/configuracoes"
            element={
              <LayoutAcademia>
                <LayoutInstrutor>
                  <ConfiguracoesInstrutor />
                </LayoutInstrutor>
              </LayoutAcademia>
            }
          />
          <Route
            path="/instrutor/configuracoes"
            element={
              <LayoutAcademia>
                <LayoutInstrutor>
                  <ConfiguracoesInstrutor />
                </LayoutInstrutor>
              </LayoutAcademia>
            }
          />

          {/* Rotas Protegidas - Aluno */}
          <Route
            path="/aluno"
            element={
              <LayoutAluno>
                <AlunoPainel />
              </LayoutAluno>
            }
          />
          <Route
            path="/aluno/cursos"
            element={
              <LayoutAluno>
                <MeusCursos />
              </LayoutAluno>
            }
          />
          <Route
            path="/aluno/certificados"
            element={
              <LayoutAluno>
                <Certificados />
              </LayoutAluno>
            }
          />
          <Route
            path="/aluno/favoritos"
            element={
              <LayoutAluno>
                <Favoritos />
              </LayoutAluno>
            }
          />
          <Route
            path="/aluno/avaliacoes"
            element={
              <LayoutAluno>
                <Avaliacoes />
              </LayoutAluno>
            }
          />
          <Route
            path="/aluno/configuracoes"
            element={
              <LayoutAluno>
                <AlunoConfiguracoes />
              </LayoutAluno>
            }
          />
          <Route
            path="/aluno/aula/:id"
            element={
              <LayoutAluno>
                <Aula />
              </LayoutAluno>
            }
          />
          <Route
            path="/aluno/curso/:id"
            element={
              <LayoutAluno>
                <CursoDetalhe />
              </LayoutAluno>
            }
          />

          {/* Rotas públicas */}
          <Route
            path="/quem-somos"
            element={
              <LayoutAcademia>
                <QuemSomos />
              </LayoutAcademia>
            }
          />
          <Route
            path="/contato"
            element={
              <LayoutAcademia>
                <ContatoAcademia />
              </LayoutAcademia>
            }
          />
          <Route
            path="/cursos"
            element={
              <LayoutAcademia>
                <CursosAcademia />
              </LayoutAcademia>
            }
          />
          <Route
            path="/curso1"
            element={
              <LayoutAcademia>
                <Curso1 />
              </LayoutAcademia>
            }
          />
          <Route
            path="/curso2"
            element={
              <LayoutAcademia>
                <Curso2 />
              </LayoutAcademia>
            }
          />
          <Route
            path="/curso3"
            element={
              <LayoutAcademia>
                <Curso3 />
              </LayoutAcademia>
            }
          />
          <Route
            path="/curso4"
            element={
              <LayoutAcademia>
                <Curso4 />
              </LayoutAcademia>
            }
          />
          <Route path="/curso/:id" element={<CursoDetalhe />} />

          <Route path="*" element={<Navigate to="/academia" replace />} />
        </Routes>
      </Suspense>
    </div>
  );
};

export default RotasAcademia;
